import AirDatepicker from 'air-datepicker';
import localeDe from 'air-datepicker/locale/de';

const dateElements = Array.from(document.querySelectorAll('.js-form-element-datepicker'));

if (dateElements && dateElements.length > 0) {
  dateElements.forEach(function(dateElement) {
    let dp = new AirDatepicker(dateElement, {
      locale: localeDe,
    });
  });
}
